import { render } from "./appPageTrainCourse.vue?vue&type=template&id=58a39568&scoped=true"
import script from "./appPageTrainCourse.vue?vue&type=script&lang=js"
export * from "./appPageTrainCourse.vue?vue&type=script&lang=js"

import "./appPageTrainCourse.vue?vue&type=style&index=0&id=58a39568&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a39568"]])

export default __exports__